// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  padding: 24px;
}

ion-item {
  --background: #f8f9fb;
}

#contacts-chart-col {
  padding: 0;
}
#contacts-chart-col #contacts-chart-container {
  min-width: 142px;
  max-width: 142px;
  margin-left: auto;
  margin-right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#contacts-chart-col #contacts-chart-counter {
  position: absolute;
  font-size: 27px;
  font-weight: 700;
  color: var(--ion-color-dark);
}

#contacts-stats-col {
  --padding-start: 0;
  --padding-end: 24px;
}

#contacts-stats-col p,
#contacts-stats-col ion-note {
  font-size: 14px;
  font-weight: 700;
  color: var(--ion-text-color);
}
#contacts-stats-col ion-item {
  --padding-start: 0px;
  --padding-end: 24px;
}
#contacts-stats-col .contact-bullet {
  width: 20px;
  height: 8px;
  display: block;
  margin-bottom: 4px;
  margin-right: 4px;
  border-radius: 8px;
}
#contacts-stats-col .contact-bullet.not_specified {
  background: var(--ion-color-contact-chart-not-specified, var(--ion-color-medium));
}
#contacts-stats-col .contact-bullet.prospect {
  background: var(--ion-color-contact-chart-prospect-color, var(--ion-color-tertiary));
}
#contacts-stats-col .contact-bullet.client {
  background: var(--ion-color-contact-chart-client-color, var(--ion-color-secondary));
}
#contacts-stats-col .search {
  background: #99d2ff;
}
#contacts-stats-col .maps {
  background: #cf9cc8;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/views-chart-widget/views-chart-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,UAAA;AACF;AACE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAEE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,mBAAA;AADF;;AAKE;;EAEE,eAAA;EACA,gBAAA;EACA,4BAAA;AAFJ;AAKE;EACE,oBAAA;EACA,mBAAA;AAHJ;AAME;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,iFAAA;AAJN;AAOI;EACE,oFAAA;AALN;AAQI;EACE,mFAAA;AANN;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,mBAAA;AATJ","sourcesContent":["ion-grid {\n  padding: 24px;\n}\n\nion-item{\n  --background: #f8f9fb;\n}\n\n#contacts-chart-col {\n  padding: 0;\n\n  #contacts-chart-container {\n    min-width: 142px;\n    max-width: 142px;\n    margin-left: auto;\n    margin-right: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  #contacts-chart-counter {\n    position: absolute;\n    font-size: 27px;\n    font-weight: 700;\n    color: var(--ion-color-dark);\n  }\n}\n\n#contacts-stats-col {\n  --padding-start: 0;\n  --padding-end: 24px;\n}\n\n#contacts-stats-col {\n  p,\n  ion-note {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--ion-text-color);\n  }\n\n  ion-item {\n    --padding-start: 0px;\n    --padding-end: 24px;\n  }\n\n  .contact-bullet {\n    width: 20px;\n    height: 8px;\n    display: block;\n    margin-bottom: 4px;\n    margin-right: 4px;\n    border-radius: 8px;\n\n    &.not_specified {\n      background: var(--ion-color-contact-chart-not-specified, var(--ion-color-medium));\n    }\n\n    &.prospect {\n      background: var(--ion-color-contact-chart-prospect-color, var(--ion-color-tertiary));\n    }\n\n    &.client {\n      background: var(--ion-color-contact-chart-client-color, var(--ion-color-secondary));\n    }\n  }\n\n  .search{\n    background: #99d2ff;\n  }\n\n  .maps{\n    background: #cf9cc8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
